import React from 'react';
import {
  Typography, Grid, Button, CircularProgress,
} from '@material-ui/core';
import useSWR from 'swr';
import axios from 'axios';
import type { IRepairItem } from '../marking/MarkingInterfaces';

const RepairProperty: React.FC<{
  repairItem: IRepairItem,
  sendNotification: (messageType: 'Empty Bin' | 'Low Stock', message: string) => void,
  setEmptyBin: (emptyBin: string) => void,
  setEmptyItemBin: (emptyBinItem: IRepairItem) => void
}> = ({
  repairItem, sendNotification, setEmptyBin, setEmptyItemBin,
}) => {
  const binFetcher = (url: string, repairItemParam: IRepairItem) => axios.get<{ metalBin: string }>(url, {
    params: {
      metalType: repairItemParam.metalType.label,
      ringWidthParameter: repairItemParam.width,
      ringThicknessParameter: repairItemParam.thickness,
      changeInSizeParameter: repairItemParam.sizeChange,
    },
  }).then((res) => res.data);

  const { data } = useSWR(repairItem ? ['/MetalCollection/GetMetalBin', repairItem] : null, (url, repairItemParam) => binFetcher(url, repairItemParam));

  return (
    <div style={{
      border: '1px solid #F2F2F2',
      boxSizing: 'border-box',
      borderRadius: '4px',
      width: '100%',
      height: '100%',
      paddingLeft: '1rem',
      paddingBottom: '0.75rem',
      paddingTop: '0.75rem',
      marginBottom: '0.25rem',
      minHeight: '7.5rem',
    }}
    >
      <Grid container>
        {
          data
            ? (
              <>
                <Grid item xs={12}>
                  <Typography variant="h5" style={{ paddingTop: '1.25rem', paddingLeft: '0.5rem', paddingBottom: '1rem' }}>{`1 ${repairItem.metalType.label} · Bin ${data?.metalBin}`}</Typography>
                </Grid>
                <Grid item xs={5}>
                  <Button id={`${repairItem.repairItemId}-add-to-reorder-list-button`} color="primary" onClick={() => sendNotification('Low Stock', data?.metalBin)}>{'Add to Reorder List'}</Button>
                </Grid>
                <Grid item>
                  <Button
                    id={`${repairItem.repairItemId}-bin-is-empty-button`}
                    color="secondary"
                    onClick={
                      () => {
                        setEmptyBin(data?.metalBin);
                        setEmptyItemBin(repairItem);
                      }
                    }
                  >
                    {'Bin is Empty'}

                  </Button>
                </Grid>
              </>
            )
            : <CircularProgress />
  }
      </Grid>
    </div>
  );
};

export default RepairProperty;
